import { VueFlux, FluxCaption, FluxPagination, FluxPreloader } from "vue-flux";
import { siteService } from "../../../services/SiteService";

export default {
    name: "PromoCarousel",

    components: {
        VueFlux,
        FluxCaption,
        FluxPagination,
        FluxPreloader
    },

    props: {
        width: Number

    },

    data: () => {
        return {
            offers: [],
            vfOptions: {
                autoplay: true,
                delay: 5000
            },
            vfTransitions: ["zip", "concentric", "round2"],
            vfImages:[],
        };
    },

    created() {
       


        siteService.getProoOffers().then(response => {
            this.offers = response.data;
        });
        this.$nextTick();
    },

    computed: {
        vfCaptions: function() {
            return this.offers
                ? this.offers.reduce((acc, offer, index) => {
                      if (offer.IsActive) {
                          acc.push({
                              text: offer.Title,
                              id: index
                          });
                      }
                      return acc;
                  }, [])
                : [];
        },
        //vfImages: function() {
        //    if (this.width < 576) {
        //        return [
        //            "img/client/mobile_promo_locuinta.jpg",
        //            "img/client/mobile_promo_casco.jpg"
        //            // "img/client/mobile_promo_cmr.png",
        //            // "img/client/mobile_promo_rot.png"
        //        ];
        //    } else {
        //        return [
        //            "img/client/promo_locuinta.jpg",
        //            "img/client/promo_casco.jpg"
        //            // "img/client/promo_cmr.png",
        //            // "img/client/promo_rot.png"
        //        ];
        //    }
        //}
    },
    destroyed() {},
    methods: {},
        watch: {
            width: {
            handler: function (val, oldVal) {
                    console.log("w=" + this.width);
                    if (this.width < 576) {
                        this.vfImages = [
                            "img/client/mobile_promo_locuinta.jpg",
                            "img/client/mobile_promo_casco.jpg"
                            // "img/client/mobile_promo_cmr.png",
                            // "img/client/mobile_promo_rot.png"
                        ];
                    } else {
                        this.vfImages = [
                            "img/client/promo_locuinta.jpg",
                            "img/client/promo_casco.jpg"
                            // "img/client/promo_cmr.png",
                            // "img/client/promo_rot.png"
                        ];
                    }
            },
            deep: true
        },
    }
};
